__turbopack_context__.v({
  "empty": "WShopRecomendedProducts-module__XOa5TW__empty",
  "header": "WShopRecomendedProducts-module__XOa5TW__header",
  "heading": "WShopRecomendedProducts-module__XOa5TW__heading",
  "productList": "WShopRecomendedProducts-module__XOa5TW__productList",
  "root": "WShopRecomendedProducts-module__XOa5TW__root",
  "showAllBtn": "WShopRecomendedProducts-module__XOa5TW__showAllBtn",
});
